import { EMPTY_AUTH, UPDATE_AUTH } from "store/actionTypes";
import { ActionType } from "utils/modals";

const initial: any = {};

const AuthReducer = (state: any = initial, action: ActionType) => {
  switch (action.type) {
    case UPDATE_AUTH:
      return { ...state, ...action.payload };
    case EMPTY_AUTH:
      return {};
    default:
      return state;
  }
};

export default AuthReducer;
